<div class="container mt-3 mx-auto">
  <div class="alert alert-info" *ngIf="!protocolos || !protocolos.length">
    Não foram encontrados arquivos de protocolo com os filtros informados.
  </div>

  <div *ngIf="protocolos?.length">
    <bn-paginacao [total]="atributosPaginacao.count"
    [tamanhoPagina]="atributosPaginacao.pageSize" [numPagina]="atributosPaginacao.page"
    [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">

      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th id="col-id-protocolo" scope="col" *ngIf="!cnpjAgente">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'siglaAgente'"
                    [nomeAtributoExibicao]="'Agente financeiro'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-id-protocolo" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'idProtocoloNegocio'"
                    [nomeAtributoExibicao]="'ID protocolo'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-modo-envio" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'apenasValidacao'"
                    [nomeAtributoExibicao]="'Modo de envio'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-data-envio" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataEnvio'" [nomeAtributoExibicao]="'Dt. envio'"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-usu-envio" scope="col" *ngIf="cnpjAgente">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'usuarioEnvio'" [nomeAtributoExibicao]="'Usu. envio'"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-status" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'statusProtocolo'"
                  [nomeAtributoExibicao]="'Status'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>

              <th id="col-tipo-protocolo" scope="col" *ngIf="exibirComboTipoArquivo">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'tipoProtocolo'"
                  [nomeAtributoExibicao]="'Tipo Protocolo'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>

              <th scope="col" class="text-end">
                  Arquivo envio
              </th>
              <th scope="col" class="text-end">
                  Arquivo resposta
              </th>
              <th></th>
              <th scope="col"></th>
              <!--lupa para visualizar os detalhes-->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let protocolo of protocolosPaginados">
              <td class="font-monospace" *ngIf="!cnpjAgente">{{ protocolo.siglaAgente }}</td>
              <td class="font-monospace">{{ protocolo.idProtocoloNegocio }}</td>
              <td class="font-monospace">{{ protocolo.apenasValidacao ? 'Apenas validação' : 'Efetivo' }}</td>
              <td>{{ protocolo.dataEnvio | date: 'dd/MM/yyyy HH:mm'}}</td>
              <td *ngIf="cnpjAgente">{{ protocolo.usuarioEnvio}}</td>
              <td>{{ obterLabelStatusProtocolo(protocolo.statusProtocolo) }}</td>
              <td *ngIf="exibirComboTipoArquivo">{{ obterTipoProtocolo(protocolo.tipoProtocolo) }}</td>
              <td class="text-end">
                  <a href="javascript:void(0)" (click)="downloadArquivoEnvio(protocolo.idProtocoloNegocio)">
                    <span class="font-monospace fw--bold"> {{ protocolo.tamanhoConteudoEnvio | fileSize }} </span>
                    <i class="fa fa-download">
                    </i>
                  </a>
              </td>
              <td class="text-end">
                <span *ngIf="protocolo.tamanhoConteudoResposta; else conteudoRespostaNaoDisponivel">
                  <a href="javascript:void(0)" (click)="downloadArquivoResposta(protocolo.idProtocoloNegocio)">
                      <span class="font-monospace fw--bold"> {{ protocolo.tamanhoConteudoResposta | fileSize }} </span>
                      <i class="fa fa-download"></i>
                  </a>
                  <span  class="ms-1" *ngIf="protocolo.conteudoRespostaContemMensagemAlerta">
                    <span> </span><i class="fas fa-exclamation-triangle color-orange" ngbTooltip="Existem avisos no arquivo de resposta."></i>
                  </span>
                </span>
                  <ng-template #conteudoRespostaNaoDisponivel>
                    <span class="font-monospace">Não disponível</span>
                  </ng-template>
              </td>

              <td *ngIf="arquivoPodeSerExcluido(protocolo)">
                <span><a (click)="excluirProtocolo(protocolo)"><i class="fa fa-trash cursor-pointer"></i></a></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </bn-paginacao>
  </div>
</div>
<ng-template #confirmacaoMensagem>
  <label for="motivoReprovacao">Deseja confirmar a exclusão do protocolo? Ao confirmar, a ação não poderá ser desfeita.</label>
</ng-template>
<ng-template #desativacaoBotoes>
  <button class="btn btn-default" (click)="cancelarExclusaoDeProtocolo()">Cancelar</button>
  <button class="btn btn-primary" (click)="confirmarExclusaoDeProtocolo()">Confirmar</button>
</ng-template>


